<template>
    <div
        class="px-4 py-2.5 rounded-xl cursor-pointer text-gray-800 no-underline hover:no-underline hover:bg-stone-100"
    >
        <slot />
    </div>
</template>
